import getSalaryStringWithOutBreak from 'wwg-utilities/dist/sharedFunctions/getSalaryWithOutBreak';
import { getTrainingType } from '../../../lib/careers';
import BrightOutlook from '../../icons/BrightOutlook';
import Education from '../../icons/Education';
import Salary from '../../icons/Salary';

interface CareerGuideShortInfoProps {
  career: any;
}

const CareerGuideShortInfo: React.FC<CareerGuideShortInfoProps> = ({
  career,
}) => {
  return (
    <>
      <section className="flex flex-wrap items-center">
        <figure className="flex items-center flex-50 shrink-0">
          <BrightOutlook className="w-6 h-6 fill-gnoIncMdBlue" />{' '}
          &nbsp;&nbsp;&nbsp;
          <figcaption className="font-medium text-gnoIncMdBlue md:text-lg font-base">
            {career.brightOutlook} Outlook
          </figcaption>
        </figure>
        <figure className="flex items-center flex-50 shrink-0">
          <Salary className="w-6 h-6 fill-gnoIncMdBlue" /> &nbsp;&nbsp;&nbsp;
          <figcaption className="font-medium capitalize text-gnoIncMdBlue md:text-lg font-base">
            {getSalaryStringWithOutBreak(career.wageData.medianAnnualSalary)}
          </figcaption>
        </figure>
        <figure className="flex items-center flex-1 my-4">
          <Education className="w-6 h-6 fill-gnoIncMdBlue" /> &nbsp;&nbsp;&nbsp;
          <figcaption className="font-medium text-gnoIncMdBlue md:text-lg font-base">
            {getTrainingType(career.trainingType)}
          </figcaption>
        </figure>
      </section>
    </>
  );
};

export default CareerGuideShortInfo;
